import axios from "axios";
import Swal from "sweetalert2";
import { tokenConfig } from "./websiteActions";
import { t } from "i18next";

export const getDropShipping = (params) => (dispatch, getState) => {
    const paramsUrl = new URLSearchParams(params).toString();
    return axios
        .get(`/api/product-drop/?${paramsUrl}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            dispatch({ type: "LOADING_DESIGN", payload: false });
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};


export const getDropShippingCategory = () => (dispatch, getState) => {
    return axios
        .get(`/api/product-drop/category`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            dispatch({ type: "LOADING_DESIGN", payload: false });
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};